import React, { useMemo } from 'react';
import { CategoryBoard } from './board/CategoryBoard';

const DragDropElement = ({ config, element, progress, onComplete, onSaveData, isCompleted }) => {
  const taskConfig = config.drag_drop_task || config;
  const zones = taskConfig.drop_zones || config.drop_zones || [];
  const rawItems = taskConfig.draggable_items || config.draggable_items || [];

  const items = useMemo(() => {
    const mapped = rawItems.map(it => ({
      id: it.id,
      text: it.text,
      imageUrl: it.image_url,
      imageAlt: it.image_alt,
      zoneId: (zones.find(z => (z.correct_items || []).includes(it.id)) || {}).id,
    })).filter(it => it.zoneId);
    return mapped.sort(() => Math.random() - 0.5);
  }, [element?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!zones.length || !items.length) {
    return <p className="text-sm text-slate-500" data-testid="drag-drop-empty">This activity has not been set up yet.</p>;
  }

  return (
    <div className="space-y-4" data-testid="drag-drop-element">
      {taskConfig.task_description && <p className="text-slate-700 text-sm">{taskConfig.task_description}</p>}
      <CategoryBoard
        items={items}
        zones={zones.map(z => ({ id: z.id, label: z.label }))}
        savedPlaced={progress?.element_progress?.[element?.id]?.placed}
        isCompleted={isCompleted}
        onSaveData={onSaveData}
        onComplete={onComplete}
        testPrefix="dd"
      />
    </div>
  );
};

export default DragDropElement;
